import React, { lazy, Suspense } from 'react';

const CustomerFooter = lazy(() => {
  switch (process.env.REACT_APP_CUSTOMER) {
    case 'frs':
      return import('owl/customers/frs/Footer');
    case 'trindco':
      return import('owl/customers/trindco/Footer');
    case 'tcf':
      return import('owl/customers/tcf/Footer');
    case 'simple':
      return import('owl/customers/simple/Footer');
    case 'dev':
      return import('owl/customers/dev/Footer');
    default:
      console.log('REACT_APP_CUSTOMER', process.env.REACT_APP_CUSTOMER);
      throw new Error('REACT_APP_CUSTOMER not set or unknown');
  }
});

export const Footer = () => {
  return (
    <>
      <Suspense>
        <CustomerFooter />
      </Suspense>
    </>
  );
};

export default Footer;
